module.exports = __webpack_public_path__ + "static/img/miyo-background.6b57ee27.png";